import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateChecklistServicoColumnsDefinition
 */

type Props = {
  onActionEditar: (idChecklistServico: number | null, openState: boolean) => void;
  onActionDeletar: (idChecklistServico: number | null, openState: boolean) => void;
  onActionCopiar: (idChecklistServico: number | null, openState: boolean) => void;
  onEnterChecklists: (idChecklistServico: number | null, newTabOpen: boolean) => void;
  onEnterChecklistsLiberacao: (idChecklistServico: number | null, newTabOpen: boolean) => void;
  onEnterVisualize: (idChecklistServico: number | null, newTabOpen: boolean) => void;
  onActionExportar: (idChecklistServico: number) => void;
};

export const GenerateChecklistServicoColumnsDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionCopiar,
  onEnterChecklists,
  onEnterChecklistsLiberacao,
  onEnterVisualize,
  onActionExportar,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Ativo";
      case 1:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "green";
      case 1:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Ativo";
      case 1:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeItemTipoTitle = (status: string) => {
    switch (status) {
      case 'C':
        return "Controlado";
      case 'E':
        return "Especializado";
      default:
        return "?";
    }
  };

  const computeItemTipoColor = (status: string) => {
    switch (status) {
      case 'C':
        return "yellow";
      case 'E':
        return "light-blue";
      default:
        return "blue";
    }
  };

  const computeItemTipoDescription = (status: string) => {
    switch (status) {
      case 'C':
        return "Controlado";
      case 'E':
        return "Especializado";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipoServico",
      filterable: false,
      headerName: "Tipo",
      minWidth: 105,
      width: 105,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemTipoTitle(params.value)}
            color={computeItemTipoColor(params.value)}
            description={computeItemTipoDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 70,
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      width: 100,
      minWidth: 100,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      )
    },
    {
      field: "revisao",
      filterable: false,
      headerName: "Revisão",
      width: 65,
      minWidth: 65,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value}
        </div>
      )
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Checklist e Inspeção",
      sortable: false,
      minWidth: 80,
      valueGetter: (_, row) => { return row['idChecklistServico'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterChecklists(value, true);
                } else {
                  onEnterChecklists(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #8e44ad',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Inspeção
            </Button>
          </div>
        );
      },
    },
    {
      field: "checklistLiberacao",
      filterable: false,
      headerName: "Checklist de Liberação",
      sortable: false,
      width: 105,
      minWidth: 105,
      valueGetter: (_, row) => { return row['idChecklistServico'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterChecklistsLiberacao(value, true);
                } else {
                  onEnterChecklistsLiberacao(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #ffa010',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Liberação
            </Button>
          </div>
        );
      },
    },
    {
      field: "visualizar",
      filterable: false,
      headerName: "Visualizar",
      sortable: false,
      minWidth: 110,
      valueGetter: (_, row) => { return row['idChecklistServico'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterVisualize(value, true);
                } else {
                  onEnterVisualize(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.6rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #4b8df8',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Visualizar
            </Button>
          </div>
        );
      },
    },
    {
      field: "ia",
      filterable: false,
      headerName: "I.A",
      width: 70,
      minWidth: 70,
      align: 'center',
      sortable: false,
      headerClassName: 'ia-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {typeof value === 'number' && `${(value * 100).toFixed(2)} %`}
        </div>
      ),
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      width: 110,
      minWidth: 110,
      valueGetter: (_, row) => { return row['idChecklistServico'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center">
            <Button
              onMouseDown={(e) => {
                onActionExportar(value);
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #35aa47',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Exportar
            </Button>
          </div>
        );
      },
    },
    {
      field: 'idChecklistServico',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 130,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => { onActionEditar(params.value, true) }}>
              <DynamicIcon nameIcon="EditRounded" size={20} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDeletar(params.value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={20} className="text-red-500" />
            </IconButton>

            <IconButton onClick={() => { onActionCopiar(params.value, true) }}>
              <DynamicIcon nameIcon="ContentCopy" size={20} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}